export default {
  'ip.list_failed': 'IP 列表查询失败，请重试。',
  'ip.invalid_query': '请检查 IP、国家代码、ASN 和风险分筛选条件。',
  'ip.members_failed': '关联会员查询失败，请重试。',
  'ip.history_budget': '历史补全预算已用完，新 IP 仍正常采集',
  'ip.library': 'IP 资料库',
  'ip.detail': 'IP 详细信息',
  'ip.unknown': '未知',
  'ip.detected': '已检测到',
  'ip.not_detected': '未检测到',
  'ip.pending': '待查询',
  'ip.running': '查询中',
  'ip.complete': '已获取',
  'ip.retry': '等待重试',
  'ip.skipped': '不可查询',
  'ip.unavailable': 'IP 资料暂不可用',
  'ip.operator_origin': '代建操作来源 IP',
  'ip.state': '状态',
  'ip.flag': '检测标签',
  'ip.latest_notice':
    '这是该 IP 的最近一次查询结果，并非历史登录当时的检测；地区表示网络出口位置。',
  'ip.permanent_notice': '查询成功后永久复用，不自动刷新；重新尝试仅用于尚未成功的 IP。',
  'ip.shared_notice': '与 RGB 共用平台额度；平台用量存在延迟，本项目保守预占额度。',
  'ip.asn': 'ASN',
  'ip.provider': '运营商',
  'ip.organisation': '所属组织',
  'ip.network_type': '网络类型',
  'ip.network_range': '网段',
  'ip.hostname': '主机名',
  'ip.country': '国家',
  'ip.country_code': '国家代码',
  'ip.region': '地区',
  'ip.city': '城市',
  'ip.timezone': '时区',
  'ip.latitude': '纬度',
  'ip.longitude': '经度',
  'ip.proxy': 'Proxy',
  'ip.vpn': 'VPN',
  'ip.hosting': '数据中心',
  'ip.tor': 'TOR',
  'ip.anonymous': '匿名网络',
  'ip.scraper': '爬虫网络',
  'ip.compromised': '受控网络',
  'ip.risk': '风险分',
  'ip.confidence': '置信度',
  'ip.operator_name': '网络服务商',
  'ip.source': '数据来源',
  'ip.api_version': '数据版本',
  'ip.checked_ts': '查询时间',
  'ip.provider_updated_ts': '平台数据更新时间',
  'ip.first_seen_ts': '首次使用',
  'ip.last_seen_ts': '最近使用',
  'ip.next_attempt_ts': '下次尝试',
  'ip.heartbeat_ts': '采集心跳',
  'ip.resume_ts': '恢复时间',
  'ip.reason': '原因',
  'ip.risk_min': '最低风险分',
  'ip.risk_max': '最高风险分',
  'ip.actions': '操作',
  'ip.members': '关联会员',
  'ip.nickname': '昵称',
  'ip.sources': '关联来源',
  'ip.registration': '注册来源',
  'ip.last_login': '最近登录来源',
  'ip.login_history': '成功登录历史',
  'ip.retry_action': '重试查询',
  'ip.queued': '已排队',
  'ip.already_queued': '已在队列中',
  'ip.cooldown': '请稍后重试',
  'ip.collector': '采集器',
  'ip.local_used': 'BOP 今日预占',
  'ip.provider_used': '平台已用',
  'ip.disabled': '已停用',
  'ip.unconfigured': '未配置密钥',
  'ip.idle': '等待任务',
  'ip.processed': '批次完成',
  'ip.paused': '已暂停',
  'ip.error': '查询异常',
  'ip.lease_expired': '等待恢复',
  'ip.backfill_incomplete': '历史回填尚未完成，关联结果可能不完整。',
  'ip.recent_30_days_and_profiles':
    '已补扫用户资料和近期登录。仅包含保留的登录记录；代建 IP 不代表玩家访问。',
  'ip.error.non_public_ip': '非公网或无效 IP',
  'ip.error.auth_error': '平台密钥不可用',
  'ip.error.rate_limited': '平台限流',
  'ip.error.daily_limit': '当日预算已用尽',
  'ip.error.provider_denied': '平台拒绝查询',
  'ip.error.network_error': '平台网络异常',
  'ip.error.http_error': '平台请求异常',
  'ip.error.invalid_response': '平台返回格式异常',
  'ip.error.usage_unavailable': '无法读取平台额度',
  'ip.error.internal_error': '采集暂不可用',
  'ip.error.invalid_or_missing_result': '该 IP 返回缺失或无效',
  'ip.error.lease_expired': '任务超时，等待重试',
  'menu.数据记录.IP 资料库': 'IP 资料库',
};
